import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SdSelectCompanyModalComponent } from '@sdvor/company/ui';
import { CollapsibleTextComponent } from '@sdvor/shared/ui';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2/models';
import { ModalService } from '@spartacus/storefront';
import { CurrentProfileService } from '@user/feature';
import { LoyaltyQrCardComponent } from './loyalty-qr-card';

@Component({
  selector: 'sd-current-profile',
  templateUrl: './current-profile.component.html',
  styleUrls: ['./current-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, AsyncPipe, SdvorIconComponent, CollapsibleTextComponent, LoyaltyQrCardComponent],
})
export class CurrentProfileComponent {
  currentProfile$ = this.currentProfileService.get();
  iconTypes = IconTypes;
  private readonly deviceService = inject(DeviceService);
  protected readonly isMobile = toSignal(this.deviceService.isMobileSmDown$);

  constructor(
    private currentProfileService: CurrentProfileService,
    private modalService: ModalService,
  ) {}

  selectProfile(): void {
    this.modalService.open(SdSelectCompanyModalComponent, {
      centered: true,
      size: 'md',
    });
  }
}
